'use client';

import { useOptionalInsurance } from '@/context/insuranceContext';
import styles from './AccountEmailInput.module.css';

export default function AccountEmailInput({
  className = '',
  value = '',
  onChange,
  placeholder,
  autoComplete = 'email',
}) {
  // Locked only inside the public calculator. Partner quote forms are outside
  // that provider, so staff can still enter another client's email there.
  const insurance = useOptionalInsurance();
  const selfServiceAccountEmail = insurance?.selfServiceAccountEmail || '';
  const locked = Boolean(selfServiceAccountEmail);

  return (
    <>
      <input
        className={`${className} ${locked ? styles.locked : ''}`}
        type='email'
        placeholder={locked ? '' : placeholder}
        value={locked ? selfServiceAccountEmail : value}
        autoComplete={autoComplete}
        readOnly={locked}
        aria-readonly={locked || undefined}
        onChange={locked ? undefined : onChange}
      />
    </>
  );
}
